import React from 'react';

import { createSvgIcon } from '@mui/material/utils';

const AirplaneProfileIcon = createSvgIcon(
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M20.475 13.2666C21.7641 13.2608 23.008 14.2266 23 15.6345C22.992 17.0355 21.7674 17.9828 20.4811 17.9999L20.4672 18.0001V18L4.77017 17.9902H4.76887L3.09168 17.9913L2.34739 17.9918L2.13328 17.279L1.72851 15.9314L1.7278 15.9291L1.07295 13.7293C0.70641 12.498 1.71097 11.4443 2.84319 11.4433C3.38416 11.4429 3.91513 11.6741 4.27445 12.1018L5.24503 13.2569L8.64849 13.2579L7.18979 8.37914C6.8067 7.09788 7.85476 5.99633 9.04123 6.00001L9.34847 6.00096C9.96613 6.00287 10.568 6.29471 10.9341 6.81948L15.4305 13.2643L20.475 13.2666ZM20.475 13.2666L20.4778 13.2666L20.4773 14.2666L20.4714 13.2666C20.4726 13.2666 20.4738 13.2666 20.475 13.2666Z"
            fill="#0875FF"
            stroke="white"
            strokeWidth="2"
        />
    </svg>,
    'AirplaneProfileIcon'
);

export default AirplaneProfileIcon;
